<template>
    <transition name="slide-fade">
        <div
            v-if="message"
            :class="{
        'text-red': message.type === 'error',
        'text-primary': message.type === 'success',
        'text-secondary': !message.type,
      }"
            class="flash-message relative bg-white rounded-md shadow-2xl overflow-hidden ml-4 fade-in z-50"
            style="min-width: 240px"
        >
            <div class="p-4 pr-10 relative pb-4 flex items-center" :class="flash ? 'flash-in':''">
                <Icon v-if="message.type === 'error'" name="warning" class="mr-2"/>
                <Icon v-if="message.type === 'success'" name="success" class="mr-2"/>
                <Icon @click.prevent="message = null" name="close" class="cursor-pointer absolute top-1/2 right-1 text-tertiary hover:text-secondary -mt-2.5" width="5" height="5" />

                <div class="flex items-center" v-html="message.text"></div>
            </div>
        </div>
    </transition>
</template>

<script>

import {watch, onMounted, ref, getCurrentInstance} from 'vue'
import Icon from "./Icon";
export default {
    components: {Icon},
    setup(){

        const message = ref(null);
        const flash = ref(false);
        const internalInstance = getCurrentInstance();
        const emitter = internalInstance.appContext.config.globalProperties.$emitter;

        let flashTimer = false;

        watch(
            () => message.value,
            () => {

                if (flashTimer) clearTimeout(flashTimer);

                flash.value = true
                flashTimer = setTimeout(() => {

                    flash.value = false;
                }, 300);
            }
        )

        onMounted(() => {
            let timer;
            emitter.on("flash-message", flashMessage => {
                clearTimeout(timer);
                message.value = flashMessage;
                timer = setTimeout(() => {

                    message.value = null;
                }, 2000);
            });
        })

        return{
            message,
            flash
        }
    }

};
</script>
<style scoped>
.slide-fade-enter-active,
.slide-fade-leave-active {
    transition: all 0.4s;
}

.slide-fade-enter,
.slide-fade-leave-to {
    transform: translateX(400px);
    opacity: 0;
}
</style>
